import { api } from './api';

export interface Template {
  id: string;
  category: string;
  name: string;
  description: string;
}

export interface TemplatesResponse {
  success: boolean;
  templates: Template[];
  categories: string[];
}

export interface GenerateMockupRequest {
  primaryImageId: string;
  primaryImageUrl?: string; // For brand logos and asset library
  secondaryImageId?: string;
  secondaryImageUrl?: string; // For asset library
  template: string;
  backgroundColor: string;
  productColor?: string;
  productTitle?: string;
  productSubtitle?: string;
  customPrompt?: string;
  showShadow?: boolean;
  scale?: number;
  aspectRatio?: string;
}

export interface GeneratedMockup {
  id: string;
  filename: string;
  template: string;
  url: string;
  generatedAt: string;
}

export interface GenerateMockupResponse {
  success: boolean;
  mockups?: GeneratedMockup[];
  error?: string;
}

export const mockupService = {
  // Get available templates
  async getTemplates(): Promise<TemplatesResponse> {
    const response = await api.get<TemplatesResponse>('/api/mockup/templates/list');
    console.log('Templates loaded:', response.data.templates.length);
    return response.data;
  },
  
  // Generate mockup
  async generateMockup(options: GenerateMockupRequest): Promise<GenerateMockupResponse> {
    console.log('Generating mockup with options:', options);
    const response = await api.post<GenerateMockupResponse>('/api/mockup/generate', options);
    console.log('Mockup generated:', response.data);
    return response.data;
  },
  
  // Get mockup info
  async getMockupInfo(mockupId: string): Promise<GeneratedMockup> {
    const response = await api.get<{ success: boolean, mockup: GeneratedMockup }>(`/api/mockup/${mockupId}`);
    return response.data.mockup;
  },
  
  // Remove background from mockup
  async removeBackground(mockupId: string): Promise<GeneratedMockup | null> {
    try {
      console.log('Removing background from mockup:', mockupId);
      const response = await api.post<{ success: boolean, mockup: GeneratedMockup, error?: string }>(`/api/mockup/remove-background`, { mockupId });
      console.log('Background removal response:', response.data);
      
      if (response.data.success && response.data.mockup) {
        return response.data.mockup;
      }
      
      throw new Error(response.data.error || 'Failed to remove background');
    } catch (error: any) {
      console.error('Error removing background:', error);
      throw error;
    }
  }
};
